export default "__VITE_ASSET__w4DATZPh__"